// extend
export { CnEllipsis, CnTextEllipsis, } from '@cainiaofe/cn-ui-m/es/components/cn-ellipsis';
